import { Controller } from "@hotwired/stimulus"

// Live preview for the Kündigungsabrechnung modal (GB-27): sums the net of the
// ticked positions and shows the pauschal deduction the invoice will carry for the
// abandoned Abbau. The server recomputes it position by position — this only saves
// the user from creating a draft to find out what it deducts.
export default class extends Controller {
  static targets = ["percent", "item", "baseOut", "deductionOut", "toggleAll"]
  static values = { currency: String }

  connect() {
    this.update()
  }

  // One handler for every checkbox and for the percent field — the preview depends
  // on both and there is nothing to distinguish.
  update() {
    const base = this.itemTargets
      .filter((item) => item.checked)
      .reduce((sum, item) => sum + this.parse(item.dataset.net), 0)
    const deduction = this.round(base * (this.parse(this.percentTarget.value) / 100))

    this.baseOutTarget.textContent = this.format(this.round(base))
    this.deductionOutTarget.textContent = `− ${this.format(deduction)}`
  }

  toggleAll() {
    const check = this.toggleAllTarget.checked
    this.itemTargets.forEach((item) => {
      item.checked = check
    })
    this.update()
  }

  round(value) {
    return Math.round(value * 100) / 100
  }

  parse(value) {
    const n = parseFloat(String(value || "").trim())
    return Number.isFinite(n) ? n : 0
  }

  // Zeichen vorangestellt, wie BillingHelper#billing_money ("%u %n") — mit der
  // Voreinstellung von Intl stünde im selben Kasten "€ 4.000,00" neben "4.890,00 €".
  format(value) {
    const symbols = { EUR: "€", CHF: "CHF", USD: "$" }
    const currency = this.currencyValue || "EUR"
    try {
      const number = new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)
      return `${symbols[currency] || currency} ${number}`
    } catch {
      return value.toFixed(2)
    }
  }
}
